// extracted by mini-css-extract-plugin
export default {"root":"root---yJ7qS","label":"label---ADiLT","separator":"separator---dL2OQ","profilePlaceholder":"profilePlaceholder---L13P9"};